
import React, { useState } from "react";
import LoadingAnimation from "components/Animations/loading";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";

import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
// @material-ui/icons components
import User from "@material-ui/icons/Person";
import Lock from "@material-ui/icons/Lock";
import Business from "@material-ui/icons/Business";

// core components
import AuthHeader from "components/Headers/AuthHeader.js";
import componentStyles from "assets/theme/views/auth/login.js";
import componentStylesButtons from "assets/theme/components/button.js";

import { login, resolveTenant } from "../../network/ApiAxios";


const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(componentStylesButtons);



function Login(props) {

  const classes = { ...useStyles(), ...useStylesButtons() };
  const theme = useTheme();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  // Operators type a short 6-digit login code; it's resolved to the real
  // tenant_key which is what every API call sends as X-Tenant-Key.
  const [loginCode, setLoginCode] = useState(localStorage.getItem("tenantLoginCode") || "");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState("");


  const tryLogin = async () => {
    setIsLoading(true);
    if (!/^\d{6}$/.test(loginCode)) {
      setError("Enter the 6-digit Tenant ID.");
      setIsLoading(false);
      return;
    }
    // Resolve the 6-digit code to the real tenant_key before logging in.
    try {
      const resolveResp = await resolveTenant(loginCode);
      const resolveData = resolveResp.data;
      if (!resolveData.result.isSuccess || !resolveData.data) {
        setError(resolveData.result.description || "Invalid Tenant ID.");
        setIsLoading(false);
        return;
      }
      localStorage.setItem("tenantId", resolveData.data);
      localStorage.setItem("tenantLoginCode", loginCode);
    } catch (e) {
      setError("Invalid Tenant ID.");
      setIsLoading(false);
      return;
    }
    const response = await login(username, password);
    const { data } = response;
    if (data.result.isSuccess) {
      setError("");
      localStorage.setItem("token", data.data.token);
      localStorage.setItem("username", data.data.username);
      localStorage.setItem("userId", data.data.userId);
      localStorage.setItem("userRole", data.data.userRole);
      localStorage.setItem("userRoles", data.data.userRoles ?? "");
      localStorage.setItem("posBranchId", data.data.posBranchId ?? "");
      localStorage.setItem("perItemServiceId", data.data.perItemServiceId ?? -99);
      localStorage.setItem("laundryName", data.data.laundryName ?? "");
      localStorage.setItem("laundryPhone", data.data.laundryPhone ?? "");
      localStorage.setItem("laundryAddress", data.data.laundryAddress ?? "");
      localStorage.setItem("countryPermissions", data.data.countryPermissions);
      if (data.data.countryPermissions != null && data.data.countryPermissions !== '') {
        localStorage.setItem("selectedCountry", data.data.countryPermissions.split(",")[0].split(":")[0]);
      }
      else {
        localStorage.setItem("countryPermissions", null);
        localStorage.setItem("selectedCountry", null);
      }
      localStorage.setItem("searchStartDate", null);
      localStorage.setItem("searchEndDate", null);
      localStorage.setItem("searchFilterBy", 0);
      localStorage.setItem("searchActiveOnly", 1);
      // Full load rather than a history push: the MUI theme and tenant logo are
      // resolved once at boot from the stored tenantId, so the freshly logged-in
      // tenant's branding only applies after the app re-mounts.
      window.location.assign("/admin");
    } else {
      setPassword("");
      setError(data.result.description);
    }
    setIsLoading(false);
  };

  return (
    <>
      <AuthHeader
        title=""
        description=""
      />
      {/* Page content */}
      <Container
        component={Box}
        maxWidth="xl"
        marginTop="-8rem"
        paddingBottom="3rem"
        position="relative"
        zIndex="101"
      >

        <div className="text-center" style={{ display: "block", marginBottom: "70px", marginTop: "70px" }}>
          <img
            alt="..."
            style={{ width: "25vh" }}
            src={require("assets/img/brand/doobi_yellow_large.png").default}
          />
        </div>
        <Box component={Grid} container justifyContent="center">
          <Grid item xs={12} lg={5} md={7}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardContent classes={{ root: classes.cardContent }}>
                <Box
                  color={theme.palette.gray[600]}
                  textAlign="center"
                  marginBottom="1rem"
                  marginTop=".5rem"
                  fontSize="1rem"
                >
                  <Box fontSize="100%" fontWeight="400">
                    Sign In
                  </Box>
                </Box>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1rem!important"
                >
                  <FilledInput
                    autoComplete="on"
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    startAdornment={
                      <InputAdornment position="start">
                        <User />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1rem!important"
                >
                  <FilledInput
                    autoComplete="on"
                    type="text"
                    inputMode="numeric"
                    inputProps={{ maxLength: 6, pattern: "[0-9]*" }}
                    placeholder="Tenant ID"
                    value={loginCode}
                    onChange={(e) =>
                      setLoginCode(e.target.value.replace(/\D/g, "").slice(0, 6))
                    }
                    startAdornment={
                      <InputAdornment position="start">
                        <Business />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1rem!important"
                >
                  <FilledInput
                    autoComplete="off"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    startAdornment={
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                {error ? (
                  <div className="text-muted text-center">
                    <small className="font-weight-600">
                      Login Failed:{" "}
                      <span className="text-red ">{error}</span>
                    </small>
                  </div>
                ) : null}
                <Box
                  textAlign="center"
                  marginTop="1.5rem"
                  marginBottom="1.5rem"
                >
                  <Button
                    variant="contained"
                    style={{ width: "90%" }}
                    color="purple100"
                    classes={{ root: classes.buttonContainedPurple100 }}
                    onClick={tryLogin}
                  >
                    Sign in
                  </Button>
                </Box>
              </CardContent>
            </Card>
            {isLoading ? (<Box component={Grid} container justifyContent="center" className="justify-content-center" ><div className="text-center" style={{ width: "30%" }} ><LoadingAnimation /></div></Box>) : null}
          </Grid>
        </Box>
      </Container>
    </>
  );
}

export default Login;
